<script lang="ts" setup>
import type {Area, Component} from "#magnolia-layer/types/magnolia-types";
import {EditableArea} from "@magnolia/vue-editor";
import {createSwiperArea} from "~/utils/swiper/createSwiperArea";

defineProps<{
  metadata: Component;
  slides?: Area;
}>();

// Note: Vue will still warn about this functional component, as the Magnolia EditableArea expects a classic component, but this will function.
const HeaderSwiper = createSwiperArea({
  pagination: {
    clickable: true,
  },
  resizeObserver: true,
  loop: true,
  effect: "creative",
  a11y: {
    enabled: true,
  },
  creativeEffect: {
    prev: {
      shadow: true,
      translate: ["-20%", 0, -1],
      opacity: 0,
    },
    next: {
      translate: ["100%", 0, 0],
    },
  },
  speed: 1_000,
  autoplay: {
    delay: 5_000,
    disableOnInteraction: true, // magnoliaContext.isMagnoliaEdit,
  },
});
</script>

<template>
  <div
    class="header-slider col-span-full bg-black overflow-hidden transform-gpu isolate">
    <EditableArea
      class="h-full"
      :content="slides"
      :customView="HeaderSwiper"></EditableArea>
  </div>
</template>

<style lang="scss" scoped>
:deep(swiper-container) {
  --swiper-navigation-color: var(--color-sunrise-100);
  --swiper-pagination-color: var(--color-sunrise-100);
  --swiper-pagination-bullet-border-radius: 0;
  --swiper-pagination-bullet-width: 40px;
  --swiper-pagination-bullet-height: 3px;
  --swiper-pagination-bullet-inactive-color: #fff;
  --swiper-pagination-bullet-inactive-opacity: 1;

  height: 100%;

  &::part(pagination) {
    display: flex;
    align-items: end;
    max-width: var(--content-max-width);
    margin: 0 auto;
    padding-inline: var(--spacing);
    right: 0;
    @apply mb-8 xl:mb-16;
  }

  &::part(bullet),
  &::part(bullet-active) {
    @apply w-4 md:w-16;
    height: 1px;
    position: relative;
    transition-property: all;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-easing);

    &::after {
      content: "";
      display: block;
      position: absolute;
      height: 40px;
      width: 100%;
      top: -20px;
    }
  }

  &::part(bullet-active) {
    background-color: var(--color-sunrise-100);
    @apply w-6 md:w-24;
    height: 3px;
  }
}

.header-slider {
  grid-column: 1 / -1;
  width: 100%;
  height: 85vh;
}
</style>
